import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import { useStaffSession } from '../../Context/StaffSessionContext';
import { getProductAppUrl, isAdminHost } from '../../Utils/constants';
import AdminBootScreen from './AdminBootScreen';

/**
 * Gate de la consola: JWT + `GET /getstaffsession`.
 * Si no es staff, la ruta se comporta como inexistente (vuelve al mapa).
 */
function leaveToProduct() {
  if (isAdminHost()) {
    window.location.replace(getProductAppUrl());
    return <AdminBootScreen />;
  }
  return <Navigate to="/app" replace />;
}

export default function StaffRoute({ children }) {
  const { isLoggedIn, isLoading: authLoading } = useAuth();
  const { isStaff, isLoading: staffLoading } = useStaffSession();

  if (authLoading || (isLoggedIn && staffLoading)) {
    return <AdminBootScreen />;
  }

  if (!isLoggedIn || !isStaff) {
    return leaveToProduct();
  }

  return children;
}
